<template>
    <div class="app">
        <div class="joinaoolication-box">
            <div
                class="joinpolicy-title-box dis-cen"
                style="margin-top: 8rem;"
            >
                <div class="jmzc"></div>
                <div class="joinpolicy-china-title">加盟申请</div>
                <div class="joinpolicy-english-title">Franchise application</div>
            </div>
            <div class="join-box dis-cen">
                <div class="join-content join-pad" style="height:auto">
                    <div class="join-rz-p">已有2905家商家入驻</div>
                    <div
                        class="application-item"
                        style="margin-top:10px"
                    >
                        <div>
                            <div class="application-name-p2">输入姓名</div>
                            <div class="application-name dis-between">
                                <input
                                    type="text"
                                    v-model="form.Name"
                                    placeholder="请输入真实姓名"
                                >
                                <div class="application-name-p">必填</div>
                            </div>
                        </div>
                        <div>
                            <div class="application-name-p2">身份证号</div>
                            <div class="application-name dis-between">
                                <input
                                    type="text"
                                    placeholder="请输入居民身份证"
                                    v-model="form.CardNo"
                                    oninput="if(value.length>18)value=value.slice(0,18)"
                                />
                                <div class="application-name-p">必填</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="application-item"
                        style="margin-top:10px"
                    >
                        <div>
                            <div class="application-name-p2">输入联系人</div>
                            <div class="application-name dis-between">
                                <input
                                    type="text"
                                    v-model="form.Contacts"
                                    placeholder="请输入联系人"
                                >
                                <div class="application-name-p">必填</div>
                            </div>
                        </div>
                        <div>
                            <div class="application-name-p2">输入手机号</div>
                            <div class="application-name dis-between">
                                <input
                                    type="number"
                                    v-model="form.Phone"
                                    oninput="if(value.length>11)value=value.slice(0,11)"
                                    placeholder="请输入手机号"
                                >
                                <div class="application-name-p">必填</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="application-item dis-between"
                        style="margin-top:2rem"
                    >
                        <div>
                            <div class="application-name-p2">选择城市</div>
                            <div class="application-name">
                                <div class="dis jal-select-box" style="width:86%">
                                    <el-select style="width:30%" v-model="provinceId" @change="provinces" placeholder="请选择">
                                        <el-option
                                            v-for="(item,index) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                    <el-select style="width:30%;margin-left:5px" v-model="cityId" @change="citys" placeholder="请选择">
                                        <el-option
                                            v-for="(item,index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                    <el-select style="width:30%;margin-left:5px" v-model="areaId" @change="areas" placeholder="请选择" v-if="areaList.length">
                                        <el-option
                                            v-for="(item,index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="application-name-p">必选</div>
                            </div>
                        </div>
                        <div>
                            <div class="application-name-p2">输入地址</div>
                            <div class="application-name">
                                <input
                                    type="text"
                                    v-model="form.Address"
                                    placeholder="请输入地址"
                                >
                                <div class="application-name-p">必填</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="application-item dis-between"
                        style="margin-top:2rem"
                    >
                        <div>
                            <div class="application-name-p2">选择类型</div>
                            <div class="application-name dis-between">
                                <div class="dis jal-radio">
                                    <el-radio v-model="form.Type" label="1">代理商</el-radio>
                                    <el-radio v-model="form.Type" label="2">加盟商</el-radio>
                                </div>
                                <div class="application-name-p">必选</div>
                            </div>
                        </div>
                        <div>
                            <div class="application-name-p2">请选择申请项目内容</div>
                            <div class="application-name jal-select-box">
                                <el-select v-model="form.CategoryId" placeholder="请选择申请内容">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <div class="application-name-p">必选</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="application-item dis-between"
                        style="margin-top:2rem"
                    >
                        <div>
                            <div class="application-name-p2">备注</div>
                            <div class="application-name">
                                <input
                                    type="text"
                                    v-model="form.Message"
                                    placeholder="请输入地址"
                                    style="width:100%"
                                >
                                <div class="application-name-p"></div>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </div>
                <div class="submit-btn" @click="submitClick">提交申请</div>
            </div>
            <!-- <div class="join_tablh">
                <div class="join_tablhs">
                    <p>填写申请表<span>(填完后, 工作人员会在3个工作日内审核联系您,请耐心等待)</span></p>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {
                provinceId: "",
                cityId: "",
                areaId: "",
                provinceList: [],
                cityList: [],
                areaList: [{}],
                form:{
                    Name:'',
                    Type: '', // 1代理商 2加盟商
                    CategoryId: '',
                    Contacts:'',
                    CardNo:'',
                    Phone:'',
                    Province:1,
                    City:2,
                    Region:3,
                    Address:'',
                    Message:''
                },
                options: [
                    {value: '1',label: '平台合作'}, 
                    {value: '2',label: '加盟合作'}, 
                    {value: '3',label: '技术合作'}, 
                    {value: '4',label: '特许代理'}
                ],
            }
        },
        created(){
            this.getcityTree()
        },
        methods:{
            submitClick() {
                this.checkTips('功能暂未开放', "error");
                return


                if (this.form.Name || this.form.Type || this.form.CardNo || this.form.Contacts || this.form.Phone || this.form.Address) {
                    this.checkTips('必填项不可为空', "error");
                    return
                }
                if (this.provinceId || this.cityId || this.areaId) {
                    this.checkTips('请选择完整的省市区', "error");
                    return
                }

                let inputData = this.form
                inputData.Province = this.provinceId
                inputData.City = this.cityId
                inputData.Region = this.areaId

                console.log(inputData)





            },
            getcityTree() {
                //获取省市区树
                this.$api.order.getcityTree().then(res => {
                    this.$loading().close()
                    console.log(res)
                    if (res.data.code == 0) {
                        this.provinceList = res.data.result
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "error")
                    }
                })
            },
            provinces(index) {
                //省
                let r = this.provinceList.find(i => i.id == index)
                this.cityList = r.children
                this.cityId = ""
                this.areaId = ""
                this.citys(this.cityList[0].id)
            },
            citys(index) {
                //市
                this.areaList =
                    this.cityList.find(i => i.id == index).children || []
                this.areas()
            },
            areas(index) {
                //区
                // this.areaId = this.areaList[ index ].id;
                // this.areaname = this.areaList[ index ].name;
                // console.log( this.areaId )
            },
            checkTips(name, type) {
                //用户提示
                this.$message({
                    message: name,
                    type: type
                })
            },

        }
    }
</script>

<style scoped="scoped">
    .jal-select-box >>> .el-input__inner {height: 30px;line-height: 30px}
    .jal-select-box >>> .el-input__icon {line-height: 30px;}
    .jal-radio >>> .el-radio__label {font-size: 16px}
    .submit-btn {
        /* width: 100%; */
        /* height: 3.25rem; */
        text-align: center;
        line-height: 3.25rem;
        /* background-color: #37A115; */
        color: #FFFFFF;
        font-size: 1.125rem;
        cursor: pointer;
        /* margin-bottom: 7rem; */
        margin: 90px 0;
        width: 430px;
        height: 54px;
        background: #0F953D;

    }

    .moreword::-webkit-input-placeholder {
        color: #999999;
        font-size: 0.875rem;
    }

    .application-name input::-webkit-input-placeholder {
        color: #333333;
        font-size: 0.875rem;
    }

    .moreword {
        width: 100%;
        height: 8.25rem;
        resize: none;
        background-color: #F5F5F5;
        border: none;
        padding: 1.6875rem;
        outline: none;
        margin-bottom: 1.5625rem;
    }

    .application-name span {
        width: 3.125rem;
        display: inline-block;
        color: #999999;
        font-size: 14px;
    }

    .application-name input {
        width: 85%;
        color: #333333;
        font-size: 0.875rem;
        outline: none;
        height: 100%;
        border: none;
        background-color: #F5F5F5;
    }

    .application-name {
        width: 27rem;
        height: 2.5rem;
        background-color: #F5F5F5;
        padding: 0 1rem;
    }

    .application-item {
        width: 100%;
        height: auto;
        /* margin-bottom: 0.75rem; */
    }

    .application-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .application-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /* .application-container {
        width: 75rem;
        height: auto;
        margin: 3.75rem auto 0 auto;
    } */

    .join_tablh {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 2.25rem;
    }

    .join_tablhs {
        width: 75rem;
    }

    .join_tablhs p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
    }

    .join_tablhs span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
    }

    .joinpolicy-line {
        width: 15.25rem;
        height: 1px;
        background-color: #37A115;
        margin: 0 5px;
    }

    .joinpolicy-begin,
    .joinpolicy-over {
        width: 0.625rem;
        height: 0.625rem;
        border-radius: 50%;
        background-color: #37A115;
    }

    .joinpolicy-linebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.625rem;
    }

    .joinpolicy-china-title {
        text-align: center;
        /* font-size: 28px;
        color: #37A115; */
        margin-top: -2.8rem;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
    }

    .joinpolicy-english-title {
        text-align: center;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        margin-top: 0.6rem;
        letter-spacing: 4px
    }

    .joinpolicy-title-box {
        width: 100%;
        height: auto;
    }

    .joinaoolication-box {
        width: 100%;
        height: auto;
        background-color: #FFFFFF;
        margin-top: 5.625rem;
    }

    .application-name-p {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #0F953D;
        line-height: 34px;
    }

    .application-name-p2 {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        margin: 25px 0
    }

    .dis-between {
        display: flex;
        justify-content: space-between
    }
</style>